import I18n from 'I18n';
import styled from 'styled-components';
import VizExLink from 'visitor-ui-component-library/link/VizExLink';
import { getFocusRingStyles } from 'visitor-ui-component-library/utils/getFocusRingStyles';
import GifBadge from './GifBadge';
import BaseThumbnailButton from './ThumbnailButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThumbnailCell = styled.div.withConfig({
  displayName: "GalleryThumbnail__ThumbnailCell"
})(["position:relative;overflow:hidden;aspect-ratio:1 / 1;background-color:", ";border:1px solid ", ";"], ({
  theme
}) => theme.spotlight.color.border, ({
  theme
}) => theme.spotlight.color.border);
const ThumbnailLink = styled(VizExLink).withConfig({
  displayName: "GalleryThumbnail__ThumbnailLink"
})(["display:block;width:100%;height:100%;"]);
const ThumbnailButton = styled(BaseThumbnailButton).withConfig({
  displayName: "GalleryThumbnail__ThumbnailButton"
})(["height:100%;", ""], ({
  theme
}) => getFocusRingStyles({
  outlineOffset: theme.spotlight.spacing.xs
}));
const ThumbnailImage = styled.img.withConfig({
  displayName: "GalleryThumbnail__ThumbnailImage"
})(["width:100%;height:100%;object-fit:cover;object-position:center;display:block;"]);
const CountOverlay = styled.div.withConfig({
  displayName: "GalleryThumbnail__CountOverlay"
})(["position:absolute;inset:0;background:rgba(0,0,0,0.55);display:flex;align-items:center;justify-content:center;color:", ";font-size:", ";font-weight:", ";"], ({
  theme
}) => theme.spotlight.color.surface, ({
  theme
}) => theme.spotlight.typography.fontSize.xxl, ({
  theme
}) => theme.spotlight.typography.fontWeight.bold);
const GalleryThumbnail = ({
  item,
  hiddenCount,
  totalCount,
  onExpand,
  onPress
}) => {
  const {
    url,
    displayName: name
  } = item.fileMetadata;
  const image = /*#__PURE__*/_jsx(ThumbnailImage, {
    src: url,
    alt: name
  });
  return /*#__PURE__*/_jsxs(ThumbnailCell, {
    children: [hiddenCount > 0 ? /*#__PURE__*/_jsxs(ThumbnailButton, {
      type: "button",
      "aria-label": I18n.text('conversations-visitor-ui.spotlight.mediaGallery.showAll', {
        count: totalCount !== null && totalCount !== void 0 ? totalCount : hiddenCount
      }),
      onClick: onExpand,
      children: [image, /*#__PURE__*/_jsx(CountOverlay, {
        "aria-hidden": "true",
        children: I18n.text('conversations-visitor-ui.spotlight.mediaGallery.moreCount', {
          count: hiddenCount
        })
      })]
    }) : onPress ? /*#__PURE__*/_jsx(ThumbnailButton, {
      type: "button",
      "aria-label": name,
      onClick: onPress,
      children: image
    }) : /*#__PURE__*/_jsx(ThumbnailLink, {
      href: url,
      target: "_blank",
      rel: "noopener noreferrer",
      children: image
    }), item.kind === 'gif' && /*#__PURE__*/_jsx(GifBadge, {
      "aria-hidden": "true",
      children: I18n.text('conversations-visitor-ui.spotlight.mediaCard.gifBadge')
    })]
  });
};
GalleryThumbnail.displayName = 'GalleryThumbnail';
export default GalleryThumbnail;